'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fuse = require('fuse.js');

var _fuse2 = _interopRequireDefault(_fuse);

var _lodash = require('lodash');

var _SelectOption = require('./SelectOption');

var _SelectOption2 = _interopRequireDefault(_SelectOption);

var _GlobalEventWrapper = require('../../Utility/GlobalEventWrapper');

var _GlobalEventWrapper2 = _interopRequireDefault(_GlobalEventWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_HOVERED_OPTION_INDEX = -1;

var SelectMenu = function (_Component) {
  _inherits(SelectMenu, _Component);

  function SelectMenu(props) {
    _classCallCheck(this, SelectMenu);

    var _this = _possibleConstructorReturn(this, (SelectMenu.__proto__ || Object.getPrototypeOf(SelectMenu)).call(this, props));

    _initialiseProps.call(_this);

    var _this$getMatches = _this.getMatches(props.filter, props.options),
        _this$getMatches2 = _slicedToArray(_this$getMatches, 2),
        matchingOptions = _this$getMatches2[0],
        fragments = _this$getMatches2[1];

    _this.fuseOptions = {
      shouldSort: true,
      includeMatches: true,
      threshold: 0.4,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: [props.displayKey]
    };

    _this.state = {
      hoveredOptionIndex: DEFAULT_HOVERED_OPTION_INDEX,
      matchingOptions: matchingOptions,
      fragments: fragments
    };
    return _this;
  }

  _createClass(SelectMenu, [{
    key: 'render',
    value: function render() {
      var menuIsOpen = this.props.menuIsOpen;

      return _react2.default.createElement(
        _GlobalEventWrapper2.default,
        { triggers: this.globalEventHandlers },
        _react2.default.createElement(
          'ul',
          {
            className: 'SelectMenu ' + (menuIsOpen ? 'active' : ''),
            ref: this.setMenuRef,
            onMouseOut: this.resetHoveredOption
          },
          this.renderOptions(),
          _react2.default.createElement(
            'li',
            { className: 'SelectMenu-empty-message' },
            'No choices match your search.'
          )
        )
      );
    }
  }]);

  return SelectMenu;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.componentDidUpdate = function (prevProps) {
    var _props = _this2.props,
        filter = _props.filter,
        options = _props.options;

    if (prevProps.filter !== filter) {
      var _getMatches = _this2.getMatches(filter, options),
          _getMatches2 = _slicedToArray(_getMatches, 2),
          matchingOptions = _getMatches2[0],
          fragments = _getMatches2[1];

      _this2.setState({
        matchingOptions: matchingOptions,
        fragments: fragments
      });
    }
  };

  this.shouldComponentUpdate = function (nextProps) {
    var menuIsOpen = _this2.props.menuIsOpen;
    // Don't re-render if closed and staying closed.

    return nextProps.menuIsOpen || menuIsOpen !== nextProps.menuIsOpen;
  };

  this.getMatches = function (filter, options) {
    var fragments = new Map();

    if (!filter) {
      return [options, fragments];
    }

    var matchingOptions = new _fuse2.default(options, _this2.fuseOptions).search(filter).map(function (match) {
      // Slipping in a side effect here
      fragments.set(match.item, match.matches);
      return match.item;
    });

    return matchingOptions.length > 0 ? [matchingOptions, fragments] : [options, fragments];
  };

  this.resetHoveredOption = function () {
    _this2.setState({ hoveredOptionIndex: DEFAULT_HOVERED_OPTION_INDEX });
  };

  this.changeHoveredOption = function (optionItem) {
    var matchingOptions = _this2.state.matchingOptions;

    var hoveredOptionIndex = _this2.getHoveredIndex();
    var optionIndex = matchingOptions.indexOf(optionItem);
    if (optionIndex >= 0 && hoveredOptionIndex !== optionIndex) {
      _this2.setState({ hoveredOptionIndex: optionIndex });
    }
  };

  this.changeHoveredOptionByDiff = function (diff) {
    var index = _this2.getHoveredIndex() + diff;
    if (index >= 0 && index < _this2.state.matchingOptions.length) {
      _this2.setState({ hoveredOptionIndex: index });
    }
  };

  this.getHoveredIndex = function () {
    return (0, _lodash.clamp)(_this2.state.hoveredOptionIndex, DEFAULT_HOVERED_OPTION_INDEX, _this2.state.matchingOptions.length - 1);
  };

  this.handleSelect = function (optionItem) {
    _this2.props.onChange(optionItem);
    _this2.setState({
      hoveredOptionIndex: DEFAULT_HOVERED_OPTION_INDEX
    });
  };

  this.handleKeyDown = function (event) {
    switch (event.key) {
      case 'ArrowUp':
        return _this2.changeHoveredOptionByDiff(-1);
      case 'ArrowDown':
        return _this2.changeHoveredOptionByDiff(1);
      case 'Enter':
        var matchingOptions = _this2.state.matchingOptions;

        var hoveredOptionIndex = _this2.getHoveredIndex();
        _this2.handleSelect(matchingOptions[hoveredOptionIndex]);
        return;
      default:
        return;
    }
  };

  this.scrollToOption = function (optionNode) {
    var focusedRect = optionNode.getBoundingClientRect();
    var menuRect = _this2.menuNode.getBoundingClientRect();
    if (focusedRect.bottom > menuRect.bottom) {
      _this2.menuNode.scrollTop = optionNode.offsetTop + optionNode.clientHeight - _this2.menuNode.offsetHeight;
    } else if (focusedRect.top < menuRect.top) {
      _this2.menuNode.scrollTop = optionNode.offsetTop;
    }
  };

  this.setMenuRef = function (menuNode) {
    _this2.menuNode = menuNode;
  };

  this.getValue = function (option, valueKey) {
    return valueKey ? option[valueKey] : option;
  };

  this.isOptionSelected = function (option) {
    var _props2 = _this2.props,
        selectedOptions = _props2.selectedOptions,
        valueKey = _props2.valueKey;

    return !!selectedOptions.find(function (opt) {
      return _this2.getValue(opt, valueKey) === _this2.getValue(option, valueKey);
    });
  };

  this.globalEventHandlers = {
    keydown: [{
      callback: this.handleKeyDown,
      conditional: function conditional(event, node) {
        return _this2.props.menuIsOpen;
      }
    }]
  };

  this.renderOptions = function () {
    var _props3 = _this2.props,
        displayKey = _props3.displayKey,
        valueKey = _props3.valueKey,
        stylingKey = _props3.stylingKey;

    var hoveredOptionIndex = _this2.getHoveredIndex();
    return _this2.state.matchingOptions.map(function (option, i) {
      var isHovered = i === hoveredOptionIndex;
      var isSelected = _this2.isOptionSelected(option);

      return _react2.default.createElement(_SelectOption2.default, {
        key: i,
        displayKey: displayKey,
        valueKey: valueKey,
        stylingKey: stylingKey,
        option: option,
        matches: _this2.state.fragments.get(option),
        scrollTo: _this2.scrollToOption,
        onClick: _this2.handleSelect,
        onHover: _this2.changeHoveredOption,
        isSelected: isSelected,
        isHovered: isHovered,
        menuNode: _this2.menuNode
      });
    });
  };
};

SelectMenu.propTypes = {
  selectedOptions: _propTypes2.default.array.isRequired,
  menuIsOpen: _propTypes2.default.bool.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  filter: _propTypes2.default.string,
  displayKey: _propTypes2.default.string.isRequired,
  valueKey: _propTypes2.default.string,
  stylingKey: _propTypes2.default.string
};

exports.default = SelectMenu;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/FormInputs/Select/SelectMenu.js
// module id = 546
// module chunks = 0